<script context="module">
  import PageHead from "./Components/PageHead.svelte";
  export { default as layout } from "./Shared/Layout.svelte";
</script>

<script>
  import { inertia } from "@inertiajs/svelte";
  import AccordionItem from "./Components/Accordion/AccordionItem.svelte";

  import AddressFaq from "./FAQ/AddressFaq.svelte";
  import HomeFaq from "./FAQ/HomeFaq.svelte";
  import PaymentFaq from "./FAQ/PaymentFaq.svelte";
  import ReminderFaq from "./FAQ/ReminderFaq.svelte";
  import RenewalFaq from "./FAQ/RenewalFaq.svelte";
</script>

<PageHead>
  <svelte:fragment slot="title">Technical Support</svelte:fragment>
  <nav aria-label="breadcrumb" slot="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a use:inertia href={window.route("home")}>Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Technical Support
      </li>
    </ol>
  </nav>
</PageHead>

<div class="row">
  <div class="col-12 col-md-6">
    <HomeFaq title={"Online Renewal"} parentId="renewalFaq">
      <RenewalFaq title={false} parentId="renewalFaq" />
      <AccordionItem>
        <div slot="header">Can I renew more than 1 vehicle at a time?</div>
        <div slot="content">
          Yes, you can renew multiple vehicles at one time as long as they are
          within the 90 day renewal period.
        </div>
      </AccordionItem>
      <AccordionItem>
        <div slot="header">
          When renewing I received a "Cannot Renew Before 90 Days of Prior
          Expiration Date" message. What does this mean?
        </div>
        <div slot="content">
          You are not eligible to renew online before 90 days of the renewal
          expiration.
        </div>
      </AccordionItem>
      <AccordionItem>
        <div slot="header">
          When renewing I received an "Invalid Vehicle Type" message. What does
          this mean?
        </div>
        <div slot="content">
          The vehicle information you are entering is invalid or the vehicle you
          are trying to renew cannot be renewed online.
        </div>
      </AccordionItem>
      <AccordionItem>
        <div slot="header">
          What is the Affidavit of Non Use agreement appearing on my Renewal?
        </div>
        <div slot="content">
          If your vehicle license plate has expired you are charged a late fee
          penalty. If you have not driven the vehicle during the lapsed renewal
          time you have the option to agree to the "Affidavit of Non-use" and
          the late fee penalty will be revoked.
        </div>
      </AccordionItem>
      <AccordionItem>
        <div slot="header">
          Can I renew my registration online and pick up my decal at my local
          DMV office or do they have to be mailed to me?
        </div>
        <div slot="content">
          If renewing online the decal will have to be mailed to your mailing
          address.
        </div>
      </AccordionItem>
      <AccordionItem>
        <div slot="header">
          When I click "Get Started" from the main menu, there is no search box
          to find my vehicle OR I see a message that says "You must enable
          javascript to use this system."
        </div>
        <div slot="content">
          Make sure your browser has Javascript enabled. See
          <a
            href="https://support.microsoft.com/en-us/office/enable-javascript-7bb9ee74-6a9e-4dd1-babf-b0a1bb136361"
            >https://support.microsoft.com/en-us/office/enable-javascript-7bb9ee74-6a9e-4dd1-babf-b0a1bb136361</a
          >
          for help with turning on Javascript.
        </div>
      </AccordionItem>
    </HomeFaq>
  </div>
  <div class="col-12 col-md-6">
    <div class="alert alert-primary" role="alert">
      Can't find what you're looking for? <a
        href="https://www.ark.org/support/index.php?projectid=1973"
        class="alert-link">Report a Problem</a
      >
    </div>
    <AddressFaq title={"Address Changes"} />
    <br />
    <PaymentFaq title={"Payment"} />
    <br />
    <ReminderFaq title={"Reminders"} />
    <br />
    <div class="card">
      <p
        class="fs-5 bg-success text-bg-success mb-0 p-2 border-bottom text-center"
      >
        Telephone Assistance
      </p>
      <div class="card-body">
        <ul>
          <li>
            For questions about your vehicle registration, please call the
            Department of Finance and Administration helpdesk at <a
              href="tel:18883898336">1-888-389-8336</a
            >. Monday-Friday 8AM-4:30PM.
          </li>
          <li>
            For technical questions about this website, please call <a
              href="tel:15016821493">1-501-682-1493</a
            >.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
